import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Card } from '@/components/ui/Card';
import { TextField } from '@/components/forms/TextField';
import { PARTNER_PROFILE_STRINGS as S } from './partner-profile.strings';
import type { PartnerProfileFormValues } from './schema';

interface OnlinePresenceSectionProps {
  register: UseFormRegister<PartnerProfileFormValues>;
  errors?: FieldErrors<PartnerProfileFormValues>;
}

/**
 * The Online presence panel: LinkedIn, promo video, contact email for
 * inquiries (FR-28). No Twitter/X field - shown on the Figma edit-mode screen
 * but absent from `data-fields.md`, which outranks Figma. The read view is
 * `PartnerOnlineCard` (MYN-217).
 */
export function OnlinePresenceSection({ register, errors }: OnlinePresenceSectionProps) {
  return (
    <Card title={S.ONLINE_PRESENCE} headerDivider hoverEffect={false}>
      <div className="flex flex-col gap-4">
        {/* The two links share a row. */}
        <div className="grid gap-4 sm:grid-cols-2">
          <TextField
            {...register('linkedinUrl')}
            label={S.LINKEDIN}
            labelVariant="caps"
            type="url"
            error={errors?.linkedinUrl?.message}
          />
          <TextField
            {...register('promoVideoUrl')}
            label={S.PROMO_VIDEO}
            labelVariant="caps"
            type="url"
            error={errors?.promoVideoUrl?.message}
          />
        </div>
        <TextField
          {...register('inquiryEmail')}
          label={S.CONTACT_EMAIL_FOR_INQUIRIES}
          labelVariant="caps"
          required
          type="email"
          error={errors?.inquiryEmail?.message}
          helpText={S.CONTACT_EMAIL_FOR_INQUIRIES_HINT}
        />
      </div>
    </Card>
  );
}
